module.exports = __webpack_public_path__ + "static/img/share.885223f9.png";